import React, { useState } from 'react';
import { Edit2 } from 'lucide-react';

function EditSubscriptionModal({ subscription, onClose, onSave }) {
  const [form, setForm] = useState({
    name: subscription.name,
    email: subscription.email,
    plan: subscription.plan,
    billing: subscription.billing,
    status: subscription.status,
  });

  const handleSubmit = () => {
    if (!form.name || !form.email) return alert('Please fill all fields.');
    onSave({ ...subscription, ...form });
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: 16,
    }}>
      <div className="card animate-in" style={{ width: '100%', maxWidth: 480, maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h2 className="font-heading" style={{ fontSize: 20 }}>Edit Subscription</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: 20 }}>✕</button>
        </div>

        <div className="form-group">
          <label className="form-label">Full Name</label>
          <input className="form-control" value={form.name}
            onChange={e => setForm(p => ({ ...p, name: e.target.value }))} />
        </div>
        <div className="form-group">
          <label className="form-label">Email</label>
          <input className="form-control" type="email" value={form.email}
            onChange={e => setForm(p => ({ ...p, email: e.target.value }))} />
        </div>
        <div className="form-group">
          <label className="form-label">Plan</label>
          <select className="form-control" value={form.plan} onChange={e => setForm(p => ({ ...p, plan: e.target.value }))}>
            <option>Starter</option>
            <option>Pro Racer</option>
            <option>Champion</option>
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Billing Cycle</label>
          <select className="form-control" value={form.billing} onChange={e => setForm(p => ({ ...p, billing: e.target.value }))}>
            <option>Monthly</option>
            <option>Annual</option>
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Status</label>
          <select className="form-control" value={form.status} onChange={e => setForm(p => ({ ...p, status: e.target.value }))}>
            <option>Active</option>
            <option>Expired</option>
            <option>Cancelled</option>
          </select>
        </div>

        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 8 }}>
          <button className="btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn-primary" onClick={handleSubmit}>
            <Edit2 size={14} /> Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditSubscriptionModal;